import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeM from '../views/gb/mobile.vue'
import Home from '../views/home.vue'
import path from 'path'
// import UAParser from 'ua-parser-js';
// const uaParser = new UAParser();
// const deviceInfo = uaParser.getResult();

// const isMobileDevice = deviceInfo.device.type === 'mobile';
Vue.use(VueRouter)

/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */

export const constRoutesPc = [
	{
		path: '/',
		name: 'en-gb',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp APK Download New Version V18.80`,
			keywords: 'GBWhatsApp,GBWhatsApp Download,GB WhatsApp, GBWhatsApp APK',
			description: `Download the latest GB WhatsApp 2026 APK v18.80 for free. Get GBWhatsApp newest features, enhanced privacy, anti-ban protection, and more.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/'
				}
			]
		},
		component: Home,
	},
	{
		path: '/download-devices/',
		name: 'download-devices',
		meta: {
			appname: 'GBWhatsApp',
			title: `GBWhatsApp Download for Devices: Android, PC/Mac & Web`,
			keywords: 'GBWhatsApp Download for Devices',
			description: `Download GBWhatsApp on any device, including Android smartphones, Windows PC, macOS, and Web. Access the latest and old versions with safe APKs, installation guides, and cross-device support. `,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/download-devices/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{ text: 'Download for Devices' },
			],
		},
		component: () => import('@/views/download.vue'),
	},
	{
		path: '/change-gb-whatsapp-icon/',
		name: 'change-gb-whatsapp-icon',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Change the GB WhatsApp Icon in V18.80`,
			keywords: 'change GB WhatsApp icon, GB WhatsApp V18.80, launcher icons',
			description: `Learn how to change the GB WhatsApp icon in V18.80, explore available icon styles, fix missing icon settings, and restore the default design.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gbmodshub.com/change-gb-whatsapp-icon/`,
				},
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to: '/' },
				{ text: 'News', to: '/news/' },
				{ text: 'Tricks', to: '/news/tricks/' },
				{ text: 'How to Change the GB WhatsApp Icon in V18.80' },
			],
		},
		component: () => import('@/views/blog-25.vue'),
	},
	{
		path: '/why-gbwhatsapp-get-accounts-banned/',
		name: 'why-gbwhatsapp-get-accounts-banned',
		meta: {
			appname: 'GBWhatsApp',
			title: `Why GBWhatsApp Gets Accounts Banned (And How to Avoid It)`,
			keywords: 'Why GBWhatsApp Gets Accounts Banned, How to Avoid It',
			description: `Learn why GBWhatsApp accounts get banned and how to reduce the risk. This guide explains WhatsApp detection systems, common mistakes, and safe usage tips.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gbmodshub.com/why-gbwhatsapp-get-accounts-banned/`,
				},
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{ text: 'News', to: '/news/' },
				{ text: 'Why GBWhatsApp Gets Accounts Banned' },
			],
		},
		component: () => import('@/views/blog-24.vue'),
	},
	{
		path: '/download/gb-whatsapp-android/',
		name: 'gb-whatsapp-android',
		meta: {
			appname: 'GBWhatsApp',
			title: `Download GB WhatsApp for Android Phone`,
			keywords: 'GB WhatsApp download Android,GB WhatsApp for Android phone',
			description: `Download the latest version of GB WhatsApp for Android phones in 2026! Learn how to easily install GB WhatsApp on your Android device.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/download/gb-whatsapp-android/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'GB WhatsApp Android',
				},
			],
		},
		component: () => import('@/views/android.vue'),
	},
	{
		path: '/download/gb-whatsapp-pc/',
		name: 'gb-whatsapp-pc',
		meta: {
			appname: 'GBWhatsApp',
			title: `Download GB WhatsApp for PC & Mac (2026) – Windows 7, 8, 10, 11 `,
			keywords: 'GB WhatsApp for PC, GB WhatsApp for Mac, GB WhatsApp Windows 10',
			description: `Download GB WhatsApp for PC and Mac in 2026! Follow our easy guide to install GB WhatsApp on Windows 7, 8, 10, 11, and Mac devices. `,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/download/gb-whatsapp-pc/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'GB WhatsApp PC',
				},
			],
		},
		component: () => import('@/views/pc.vue'),
	},
	{
		path: '/download/gb-whatsapp-web/',
		name: 'gb-whatsapp-web',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB Whatsapp For Web | Download & Install In 2026 `,
			keywords: 'GB WhatsApp Web, Download GB WhatsApp Web',
			description: `Download and install GB WhatsApp on the web! Follow our easy guide to get the latest version of GB WhatsApp on the web.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/download/gb-whatsapp-web/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'GB WhatsApp Web',
				},
			],
		},
		component: () => import('@/views/web.vue'),
	},
	{
		path: '/gbwhatsapp-old-version/',
		name: 'gbwhatsapp-old-version',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Old Version Download – Stable & Lightweight APKs`,
			keywords: 'GB WhatsApp Old Version Download',
			description: `Download GB WhatsApp old versions (v18.30 v17.60,v17.65) for better performance, stability, and classic features. Safe, ad-free APKs with full privacy and UI customization.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/gbwhatsapp-old-version/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{ text: 'Old Version' },
			],
		},
		component: () => import('@/views/version.vue'),
	},
	{
		path: '/gb-whatsapp-features/',
		name: 'gb-whatsapp-features',
		meta: {
			appname: 'GBWhatsApp',
			title: `Top Features of GB WhatsApp in 2026: Customization, Privacy, and More`,
			keywords: 'Top GB WhatsApp Features ',
			description: `Explore the best features of GB WhatsApp in 2026, including advanced customization, enhanced privacy options, anti-ban features, dual WhatsApp support, and more. Learn how to make the most of this powerful WhatsApp mod!`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/gb-whatsapp-features/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{ text: 'Features' },
			],
		},
		component: () => import('@/views/features.vue'),
	},
	{
		path: '/whatsapp-mods/',
		name: 'whatsapp-mods',
		meta: {
			appname: 'GBWhatsApp',
			title: `Download WhatsApp Mods APK – 2026 Anti-Ban Updated Versions`,
			keywords: 'WhatsApp Mods',
			description: `Get the latest WhatsApp Mods APKs updated for 2026 with full anti-ban protection. Download popular mods like GB WhatsApp, FM WhatsApp, YO WhatsApp, and WhatsApp Plus – safe, fast, and ad-free.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/whatsapp-mods/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{ text: 'WhatsApp Mods' },
			],
		},
		component: () => import('@/views/mods.vue'),
	},
	{
		path: '/gbwhatsapp-ban-issues/',
		name: 'gbwhatsapp-ban-issues',
		meta: {
			appname: 'GBWhatsApp',
			title: `GBWhatsApp Ban Issues: Temporary and Permanent Ban Guide`,
			keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
			description: `Learn everything about GBWhatsApp ban issues in 2026, including how to recover from temporary bans, avoid permanent bans, and use GBWhatsApp safely. `,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/gbwhatsapp-ban-issues/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'gbwhatsapp-ban-issues',
				},
			],
		},
		component: () => import('@/views/banIssue.vue'),
	},
	
	{
		path: '/news/',
		name: 'news',
		meta: {
			appname: 'GBWhatsApp',
			title: `GBWhatsApp News & Tips`,
			keywords: 'GBWhatsApp News',
			description: `Stay up to date with the latest GBWhatsApp news, including version updates, new features, anti-ban improvements, and mod development insights. All important GB WhatsApp info in one place.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/news/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'GBWhatsApp News & Tips',
				},
			],
		},
		component: () => import('@/views/blogs.vue'),
	},
	{
		path: '/news/tricks/',
		name: 'news-tricks',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp tricks`,
			keywords: 'GBWhatsApp News',
			description: `Learn expert tricks to get the most out of GB WhatsApp.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/news/tricks/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'GB WhatsApp tricks',
				},
			],
		},
		component: () => import('@/views/blogs1.vue'),
	},
	{
		path: '/news/gbwhatsapp-update/',
		name: 'news-update',
		meta: {
			appname: 'GBWhatsApp',
			title: `GBWhatsApp Update 2026 – Latest Version Size, Release Date & News`,
			keywords: 'GBWhatsApp Update',
			description: `Get the latest GBWhatsApp update for 2026,including GB WhatsApp latest version number, latest app size, latest release time and other information.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/news/gbwhatsapp-update/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'GB WhatsApp update',
				},
			],
		},
		component: () => import('@/views/blogs2.vue'),
	},
	{
		path: '/news/wa-mods/',
		name: 'news-mods',
		meta: {
			appname: 'GBWhatsApp',
			title: `WhatsApp Mods News`,
			keywords: 'GBWhatsApp Update',
			description: `Stay updated with the newest news on WhatsApp Mods including GB WhatsApp, FM WhatsApp, YO WhatsApp, and WhatsApp Plus.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/news/wa-mods/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'WhatsApp Mods News',
				},
			],
		},
		component: () => import('@/views/blogs3.vue'),
	},
	{
		path: '/news/download-tips/',
		name: 'news-tips',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Safely & Quickly Download GBWhatsApp `,
			keywords: 'GBWhatsApp Update',
			description: `Learn essential download tips to safely install GB WhatsApp APK without errors. Follow our step-by-step guide to avoid fake files, enable unknown sources, and ensure smooth installation on your Android device.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/news/download-tips/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'GB WhatsApp tips',
				},
			],
		},
		component: () => import('@/views/blogs4.vue'),
	},
	{
		path: '/news/gb-whatsapp-update-v1840/',
		name: 'blog1',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Update Latest version v18.50`,
			keywords: 'GB WhatsApp Update,Latest version GBWhatsApp',
			description: `Discover the latest features in GB WhatsApp v18.50,including whether it is necessary to update GBWhatsApp, the latest version features, how to update to the latest version, etc.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/news/gb-whatsapp-update-v1840/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'News',to:'/news/'
				},
				{
					text: 'GB WhatsApp Update Latest Version v18.50'
				},
			],
		},
		component: () => import('@/views/blog1.vue'),
	},
	{
		path: '/news/what-is-gbwhatsapp/',
		name: 'blog2',
		meta: {
			appname: 'GBWhatsApp',
			title: `What is GB WhatsApp? Learn How to Use It Safely in 2026`,
			keywords: 'what is GB WhatsApp',
			description: `Discover what GB WhatsApp is, how it works, and how to use it securely in 2026. Get insights into features, privacy settings, and safe installation tips to avoid bans or fake APKs.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/news/what-is-gbwhatsapp/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'News',to:'/news/'
				},
				{
					text: 'What is GB WhatsApp? Learn How to Use It Safely in 2026'
				},
			],
		},
		component: () => import('@/views/blog2.vue'),
	},
	{
		path: '/how-to-install-gb-whatsapp/',
		name: 'blog3',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Install GB WhatsApp Safely`,
			keywords: 'Install GBWhatsApp',
			description: `Discover how to install GB WhatsApp safely and quickly on your Android device with this step-by-step guide, including FAQs and expert tips.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/how-to-install-gb-whatsapp/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'News',to:'/news/'
				},
				{
					text: 'How to Install GB WhatsApp Safely'
				},
			],
		},
		component: () => import('@/views/blog-3.vue'),
	},
	{
		path: '/how-to-update-gb-whatsapp/',
		name: 'blog4',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Update GB WhatsApp: A Complete Guide for 2026`,
			keywords: 'Install GBWhatsApp',
			description: `Learn how to safely update GB WhatsApp TDK to the latest version. Follow our step-by-step guide to back up your chats, install the new APK.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/how-to-update-gb-whatsapp/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'News',to:'/news/'
				},
				{
					text: 'How to Update GB WhatsApp: A Complete Guide for 2026'
				},
			],
		},
		component: () => import('@/views/blog-4.vue'),
	},
	{
		path: '/advanced-customization-options-in-gb-whatsapp/',
		name: 'blog5',
		meta: {
			appname: 'GBWhatsApp',
			title: `Advanced Customization Options in GB WhatsApp`,
			keywords: 'GB WhatsApp customization',
			description: `Discover the advanced customization options in GB WhatsApp that let you personalize chats, privacy settings, themes, and more like never before.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/advanced-customization-options-in-gb-whatsapp/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'News',to:'/news/'
				},
				{
					text: 'Advanced Customization Options in GB WhatsApp'
				},
			],
		},
		component: () => import('@/views/blog-5.vue'),
	},
	{
		path: '/enhanced-privacy-settings-in-gb-whatsapp/',
		name: 'blog6',
		meta: {
			appname: 'GBWhatsApp',
			title: `Take Control: Unlocking Enhanced Privacy Settings in GB WhatsApp`,
			keywords: 'GB WhatsApp Privacy Set',
			description: `Step beyond basic privacy! Discover how Enhanced Privacy Settings in GB WhatsApp give you full control over your digital footprint and secure messaging.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/enhanced-privacy-settings-in-gb-whatsapp/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'News',to:'/news/'
				},
				{
					text: 'Unlocking Enhanced Privacy Settings in GB WhatsApp'
				},
			],
		},
		component: () => import('@/views/blog-6.vue'),
	},
	{
		path: '/gb-whatsapp-not-install-or-download-fix/',
		name: 'blog7',
		meta: {
			appname: 'GBWhatsApp',
			title: `Why Is My Phone Not Downloading or Installing GB WhatsApp?`,
			keywords: 'GB WhatsApp not installing',
			description: `Trouble installing GB WhatsApp on Android? Learn why your phone won't download or install the APK and how to fix issues like unknown sources, Play Protect, storage, and version compatibility.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/gb-whatsapp-not-install-or-download-fix/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'News',to:'/news/'
				},
				{
					text: 'Why Is My Phone Not Downloading or Installing GB WhatsApp?'
				},
			],
		},
		component: () => import('@/views/blog-7.vue'),
	},
	{
		path: '/why-gb-whatsapp-risks-don\'t-stop-its-users/',
		name: 'gb-whatsapp-risks-blog',
		meta: {
			appname: 'GBWhatsApp',
			title: `Why GB WhatsApp Risks Don't Stop Its Users`,
			keywords: 'GB WhatsApp risks, GB WhatsApp Latest Version',
			description: `GB WhatsApp risks haven't stopped users from downloading it. Discover why it remains popular in 2026 and how to stay safe with the latest version.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/why-gb-whatsapp-risks-don\'t-stop-its-users/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'News',to:'/'
				},
				{
					text: 'Why GB WhatsApp Risks Don\'t Stop Its Users'
				},
			],
		},
		component: () => import('@/views/blog-8.vue'),
	},
	{
		path: '/how-to-save-whatsapp-status/',
		name: 'blog9',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Save WhatsApp Status: The Easy Way with GBWhatsApp`,
			keywords: 'Save WhatsApp Status',
			description: `Looking to save WhatsApp Status updates? GBWhatsApp simplifies the process with an integrated download button. One tap is all it takes to keep what matters.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/how-to-save-whatsapp-status/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'News',to:'/news/'
				},
				{
					text: 'How to Save WhatsApp Status: The Easy Way with GBWhatsApp'
				},
			],
		},
		component: () => import('@/views/blog-9.vue'),
	},
	{
		path: '/gb-whatsapp-v18.60-released-fixed-banned-numbers/',
		name: 'blogs-10',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp v18.60 Released – Fixed Banned Numbers & More!`,
			keywords: 'GB WhatsApp v18.60',
			description: `GB WhatsApp v18.60 fixes banned number issues, adds new privacy tools, performance upgrades, and fresh themes—download the July 2026 update now!`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/gb-whatsapp-v18.60-released-fixed-banned-numbers/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'News',to:'/news/'
				},
				{
					text: 'GB WhatsApp v18.60 Released – Fixed Banned Numbers & More!'
				},
			],
		},
		component: () => import('@/views/blogs-10.vue'),
	},
	{
		path: '/how-gb-whatsapp-protects-your-data/',
		name: 'blog-11',
		meta: {
			appname: 'GBWhatsApp',
			title: `How GB WhatsApp Ensures Strong Data Protection for Users`,
			keywords: 'data protection',
			description: `Data protection is key with GB WhatsApp. Discover how its unique privacy tools keep your messages, personal info, and conversations secure and private.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/how-gb-whatsapp-protects-your-data/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'News',to:'/news/'
				},
				{
					text: 'How GB WhatsApp Ensures Strong Data Protection for Users'
				},
			],
		},
		component: () => import('@/views/blog-11.vue'),
	},
	{
		path: '/gbwhatsapp-qr-chat/',
		name: 'blog-12',
		meta: {
			appname: 'GBWhatsApp',
			title: `GBWhatsApp QR Chat: Start Conversations Without Saving Numbers`,
			keywords: 'GBWhatsApp QR Chat',
			description: `GBWhatsApp QR Chat lets you start chats instantly without saving numbers, making messaging faster, simpler, and more private for daily use.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/gbwhatsapp-qr-chat/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'News',to:'/news/'
				},
				{
					text: 'GBWhatsApp QR Chat: Start Conversations Without Saving Numbers'
				},
			],
		},
		component: () => import('@/views/blog-12.vue'),
	},
	{
		path: '/send-high-quality-pictures-in-whatsapp/',
		name: 'blog-13',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Send High Quality Pictures in WhatsApp (No Compression)?`,
			keywords: 'Send Pictures in WhatsApp',
			description: `Send high-quality photos on WhatsApp without losing detail. GBWhatsApp lets you share pictures in full resolution, keeping every memory sharp and vibrant for friends and family.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/send-high-quality-pictures-in-whatsapp/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'News',to:'/news/'
				},
				{
					text: 'Tricks',to:'/news/tricks/'
				},
				{
					text: 'How to Send High Quality Pictures in WhatsApp (No Compression)?'
				},
			],
		},
		component: () => import('@/views/blog-13.vue'),
	},
	{
		path: '/create-manage-gwhatsapp-groups/',
		name: 'blog-14',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Create and Manage Groups on GB WhatsApp`,
			keywords: 'GB WhatsApp groups',
			description: `Learn how to create and manage groups on GB WhatsApp with ease. Discover features, privacy settings, and best practices for smooth group chats.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/create-manage-gwhatsapp-groups/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'News',to:'/news/'
				},
				{
					text: 'How to Create and Manage Groups on GB WhatsApp'
				},
			],
		},
		component: () => import('@/views/blog-14.vue'),
	},
	{
		path: '/create-manage-gwhatsapp-groups-new/',
		name: 'blog-15',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Create and Manage Groups on GB WhatsApp`,
			keywords: 'GB WhatsApp groups',
			description: `Learn how to create and manage groups on GB WhatsApp with ease. Discover features, privacy settings, and best practices for smooth group chats.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/create-manage-gwhatsapp-groups-new/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'News',to:'/news/'
				},
				{
					text: 'How to Create and Manage Groups on GB WhatsApp'
				},
			],
		},
		component: () => import('@/views/blog-15.vue'),
	},
	{
		path: '/gbwhatsapp-for-business-privacy/',
		name: 'blog-16',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Use GBWhatsApp for Business Without Compromising Privacy`,
			keywords: 'GBWhatsApp for business, GBWhatsApp privacy tips, secure GBWhatsApp settings, use GBWhatsApp safely, GBWhatsApp dual accounts, business WhatsApp alternative',
			description: `Learn how to use GBWhatsApp for business while keeping your privacy safe. Learn the best settings, features, and tips to protect sensitive data and manage work chats effectively.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/gbwhatsapp-for-business-privacy/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'News',to:'/news/'
				},
				{
					text: 'Tricks',to:'/news/tricks/'
				},
				{
					text: 'How to Use GBWhatsApp for Business Without Compromising Privacy'
				},
			],
		},
		component: () => import('@/views/blog-16.vue'),
	},
	{
		path: '/lock-chats-gbwhatsapp/',
		name: 'blog-17',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Lock Chats in GBWhatsApp`,
			keywords: 'lock chats in GBWhatsApp',
			description: `Learn how to lock chats in GBWhatsApp using built-in security features. Step-by-step guide to protect private conversations with pattern, PIN, or fingerprint lock.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/lock-chats-gbwhatsapp/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{
					text: 'News',to:'/news/'
				},
				{
					text: 'Tricks',to:'/news/tricks/'
				},
				{
					text: 'How to Lock Chats in GBWhatsApp'
				},
			],
		},
		component: () => import('@/views/blog-17.vue'),
	},
	{
		path: '/dual-whatsapp-accounts-gbwhatsapp/',
		name: 'blog-18',
		meta: {
			appname: 'GBWhatsApp',
			title: `Dual WhatsApp Accounts – Manage Multiple WhatsApp on One Device`,
			keywords: 'dual whatsapp accounts, multiple whatsapp',
			description: `Learn how to use Dual WhatsApp Accounts on one phone. Manage personal and business accounts simultaneously with GB WhatsApp features.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/dual-whatsapp-accounts-gbwhatsapp/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to: '/' },
				{ text: 'Features', to: '/gb-whatsapp-features/' },
				{ text: 'Dual WhatsApp Accounts' },
			],
		},
		component: () => import('@/views/blog-18.vue'),
	},
	{
		path: '/gb-whatsapp-larger-file-sharing/',
		name: 'blog-19',
		meta: {
			appname: 'GBWhatsApp',
			title: `Larger File Sharing in GB WhatsApp – Send Big Files Easily`,
			keywords: 'larger file sharing, send big files',
			description: `Share larger files up to 100MB effortlessly with GB WhatsApp. Learn how to send videos, documents, and media without restrictions.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/gb-whatsapp-larger-file-sharing/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to: '/' },
				{ text: 'Features', to: '/gb-whatsapp-features/' },
				{ text: 'Larger File Sharing' },
			],
		},
		component: () => import('@/views/blog-19.vue'),
	},
	{
		path: '/multiple-media-selection-gbwhatsapp/',
		name: 'blog-20',
		meta: {
			appname: 'GBWhatsApp',
			title: `Multiple Media Selection – Share Photos & Videos Easily`,
			keywords: 'multiple media selection, send multiple images',
			description: `Discover Multiple Media Selection in GB WhatsApp. Send multiple images and videos at once without any hassle. Perfect for efficient chatting.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/multiple-media-selection-gbwhatsapp/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to: '/' },
				{ text: 'Features', to: '/gb-whatsapp-features/' },
				{ text: 'Multiple Media Selection' },
			],
		},
		component: () => import('@/views/blog-20.vue'),
	},
	{
		path: '/built-in-app-lock-gbwhatsapp/',
		name: 'blog-21',
		meta: {
			appname: 'GBWhatsApp',
			title: `Built-in App Lock – Secure Your GB WhatsApp`,
			keywords: 'GB WhatsApp built-in app lock',
			description: `Secure your chats with the Built-in App Lock feature in GB WhatsApp. Protect messages with PIN, Pattern, or Fingerprint lock easily.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/built-in-app-lock-gbwhatsapp/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to: '/' },
				{ text: 'Features', to: '/gb-whatsapp-features/' },
				{ text: 'Built-in App Lock' },
			],
		},
		component: () => import('@/views/blog-21.vue'),
	},
	{
		path: '/disappearing-messages-gbwhatsapp/',
		name: 'blog-22',
		meta: {
			appname: 'GBWhatsApp',
			title: `Disappearing Messages – Keep Your Chats Private with GB WhatsApp`,
			keywords: 'disappearing messages, temporary messages',
			description: `Learn how to use Disappearing Messages in GB WhatsApp. Send messages that vanish automatically for enhanced privacy and clutter-free conversations.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/disappearing-messages-gbwhatsapp/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to: '/' },
				{ text: 'Features', to: '/gb-whatsapp-features/' },
				{ text: 'Disappearing Messages' },
			],
		},
		component: () => import('@/views/blog-22.vue'),
	},
	{
		path: '/status-download-feature-gbwhatsapp/',
		name: 'blog-23',
		meta: {
			appname: 'GBWhatsApp',
			title: `Status Download Feature – Save WhatsApp Status Easily with GB WhatsApp`,
			keywords: 'status download feature, download whatsapp status, save whatsapp stories',
			description: `Learn how to download WhatsApp statuses with GB WhatsApp. Save friends' photos and videos effortlessly while maintaining original quality.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/status-download-feature-gbwhatsapp/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to: '/' },
				{ text: 'Features', to: '/gb-whatsapp-features/' },
				{ text: 'Status Download Feature' },
			],
		},
		component: () => import('@/views/blog-23.vue'),
	},
	{
		path: '/fm-whatsapp-vs-gb-whatsapp/',
		name: 'FMWhatsApp',
		meta: {
			appname: 'FMWhatsApp',
			title: `FM WhatsApp vs GB WhatsApp Features: What Makes FM Stand Out`,
			keywords: 'FM WhatsApp vs GB WhatsApp',
			description: `FM WhatsApp vs GB WhatsApp comparison revealing top features, privacy tools, and why FM WhatsApp offers a smarter, safer, and more customizable messaging experience.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/fm-whatsapp-vs-gb-whatsapp/'
				}
			],
			breadcrumb: [
				{ text: 'FM WhatsApp', to:'/' },
				{
					text: 'FM WhatsApp vs GB WhatsApp Comparison'
				},
			],
		},
		component: () => import('@/views/FMWhatsApp.vue'),
	},
	{
		path: '/privacy-policy/',
		name: 'privacy-policy',
		meta: {
			appname: 'GBWhatsApp',
			title: `Privacy Policy-WhatsApp Modded Privacy`,
			// keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
			description: `Read the privacy policy for gbmodshub.com. Learn about how we collect, use, and protect your personal data when you visit or interact with our site, including the use of cookies and third-party links.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/privacy-policy/'
				},
			],
		},
		component: () => import('@/views/privacy.vue'),
	},
	{
		path: '/contact-us/',
		name: 'contact-us',
		meta: {
			appname: 'GBWhatsApp',
			title: `Contact Us - Get in Touch with gbmodshub.com Team`,
			// keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
			description: `Have questions or need support? Contact the gbmodshub.com team for help with GB WhatsApp downloads, updates, and general inquiries. We're here to assist you.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/contact-us/'
				},
			],
		},
		component: () => import('@/views/contact.vue'),
	},
	{
		path: '/disclaimer/',
		name: 'disclaimer',
		meta: {
			appname: 'GBWhatsApp',
			title: `Disclaimer - GB WhatsApp Download Notice`,
			// keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
			description: `Read the official disclaimer of gbmodshub.com. We are not affiliated with WhatsApp Inc. Use GB WhatsApp and other modded apps at your own risk.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/disclaimer/'
				},
			],
		},
		component: () => import('@/views/disclaimer.vue'),
	},
	{
		path: '/about-us/',
		name: 'about-us',
		meta: {
			appname: 'GBWhatsApp',
			title: `About Us- gbappslive`,
			// keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
			description: `Learn more about gbmodshub.com –provided your trusted source for the latest GB WhatsApp and WhatsApp mod APKs download.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/about-us/'
				}
			],
		},
		component: () => import('@/views/about.vue'),
	},
	{
		path: '/terms-of-use',
		name: 'terms-of-use',
		meta: {
			appname: 'GBWhatsApp',
			title: `Terms of Use`,
			// keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
			description: `Read the Terms of Use for gbmodshub.com. We are not the developers of GBWhatsApp and only provide safe download links and information.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/terms-of-use/'
				}
			],
			noindex: true
		},
		component: () => import('@/views/termsUse.vue'),
	},
	{
		path: '/transfer',
		name: 'transfer',
		meta: {
			appname: 'GBWhatsApp',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/transfer/'
				}
			]
		},
		component: () => import('@/views/transfer.vue'),
	},
	{
		path: '/yo-whatsapp-download/',
		name: 'yo-whatsapp-download',
		meta: {
			appname: 'YOWhatsApp',
			title: `YO WhatsApp APK Download Latest Version – Android 2026`,
			keywords: 'YO WhatsApp APK, YO WhatsApp latest version, YO WhatsApp download',
			description: `Download YO WhatsApp APK latest version for Android. Get the newest YO WhatsApp features, enhanced privacy, custom themes, and improved media sharing.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/yo-whatsapp-download/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{ text: 'YO WhatsApp Download' },
			],
		},
		component: () => import('@/views/yoWhatsappDownload.vue'),
	},
	{
		path: '/whatsapp-plus-download/',
		name: 'whatsapp-plus-download',
		meta: {
			appname: 'WhatsAppPlus',
			title: `WhatsApp Plus APK Download Latest Version – Android 2026`,
			keywords: 'WhatsApp Plus APK, WhatsApp Plus latest version, WhatsApp Plus download, WhatsApp Plus MOD, Android APK download',
			description: `Get WhatsApp Plus APK latest version for Android. Download the newest WhatsApp Plus MOD with advanced privacy, customization, and media sharing features.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/whatsapp-plus-download/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{ text: 'WhatsApp Plus Download' },
			],
		},
		component: () => import('@/views/whatsappPlusDownload.vue'),
	},
	{
		path: '/fm-whatsapp-download/',
		name: 'fm-whatsapp-download',
		meta: {
			appname: 'FMWhatsApp',
			title: `FM WhatsApp APK Download (Latest Version 2026) – Updated & Safe MOD`,
			keywords: 'FM WhatsApp Download, FM WhatsApp APK',
			description: `Download the latest version of FM WhatsApp APK (Updated for 2026) with advanced privacy features, anti-ban support, and extra customization. Fast, secure, and 100% working FM WhatsApp MOD APK free download.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbmodshub.com/fm-whatsapp-download/'
				}
			],
			breadcrumb: [
				{ text: 'GB WhatsApp', to:'/' },
				{ text: 'FM WhatsApp Download' },
			],
		},
		component: () => import('@/views/fmWhatsappDownload.vue'),
	},
]

// export const constRoutesM = [
// 	{
// 		path: '/',
// 		name: 'Home',
// 		meta: {
// 			appname: 'GBWhatsApp',
// 			topLogo: require('@/assets/gb/GB_new_icon_small@2x.png'),
// 			footLogo: require('@/assets/gb/icon_GB_new@2x.png'),
// 			showBreadcrumb: true,
// 			showTelegram: true,
// 		},
// 		// component: HomeM,
// 	},
// 	{
// 		path: '/download',
// 		name: 'download',
// 		meta: {
// 			appname: 'GBWhatsApp',
// 			topLogo: require('@/assets/gb/GB_new_icon_small@2x.png'),
// 			footLogo: require('@/assets/gb/icon_GB_new@2x.png'),
// 			showBreadcrumb: false,
// 		},
// 		component: () => import('@/components/download.vue'),
// 	},
// ]

let routes = []
// if (isMobileDevice) {
// 	routes = constRoutesM
// }
// if (!isMobileDevice) {
// 	routes = constRoutesPc
// }

routes = constRoutesPc
export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
